<template>
  <vs-row class="table-pagination my-5" vs-w="12" vs-type="flex" vs-justify="flex-end" vs-align="center">
    <div class="btn-group">
      <vs-button @click="prevPage" :class="{'pagination-disabled': page <= 1 && current <= 1 ? 'pagination-disabled' : null}"
      color="dark" type="line" icon-pack="feather" icon="icon-arrow-left-circle" size="large">Indietro</vs-button>
    </div>
    <div v-if="custom_pager" class="btn-group ml-6">
      <vs-button v-if="custom_pager.tot" color="black" type="line" disabled>{{['Pag:',custom_pager.current,'/',custom_pager.tot].join(' ')}}</vs-button>
    </div>
    <div v-else class="btn-group ml-6">
      <vs-button v-if="total" color="black" type="line" size="large" disabled>{{['Pag:',current,'/',total].join(' ')}}</vs-button>
    </div>
    <div class="btn-group mr-6 ml-6">
      <vs-button @click="nextPage" :class="{'pagination-disabled': (current === total) && !hasNext ? 'pagination-disabled' : null}"
       color="dark" type="line" icon-pack="feather" icon="icon-arrow-right-circle" size="large" icon-after>Avanti</vs-button>
    </div>
  </vs-row>
</template>
<script>

export default {
  name: 'Pager',
  props:{
    color:{
      type:String,
      default:'primary'
    },
    total:{
      type:Number,
      required:true
    },
    value:{
      type:Number,
      required:true,
      default: 1
    },
    max:{
      type:Number,
      default:9
    },

    goto:{
      type:Boolean
    },
    type:{
      type:String
    },
    prevIcon:{
      type:String,
      default:'chevron_left'
    },
    nextIcon:{
      type:String,
      default:'chevron_right'
    },
    iconPack:{
      type:String,
      default:'material-icons'
    },
    hasNext:{
      default: true,
      type: Boolean
    },
    page:{
      default: 1,
      type: Number
    },
    custom_pager:{
      type: Object
    }
  },
  data: () => ({
    pages: [],
    current: 0,
    go: 0,
    prevRange: '',
    nextRange: '',
    hoverBtn1: false
  }),
  // computed: {
  //   stylePagination () {
  //     let style = {}
  //     if (!_color.isColor(this.color)) {
  //       style = {
  //         '--vs-color-pagination': _color.getColor(this.color),
  //         '--vs-color-pagination-alpha': _color.getColor(this.color,.5)
  //       }
  //     }
  //     return style
  //   },
  // },
  watch: {
    current() {
      this.getPages()
      this.$emit('input', this.current)
      this.$emit('change', this.current)
    },
    total() {
      this.getPages()
    },

    max() {
      this.getPages()
    },
    value(val) {
        const pageNum = val < 1 ? 1 : (val <= this.total ? val : this.total)
        this.goTo(pageNum)
    }
  },
  mounted () {
    this.current = this.go = this.value
    this.getPages()
  },
  methods:{
    isEllipsis(page) {
      return page === '...'
    },
    goTo(page) {
      if(page === '...') {
        return
      }
      if (typeof page.target === 'undefined') {
        this.current = page
      } else {
        const value  = parseInt(page.target.value, 10)
        this.go      = (
          value < 1 ? 1 : (value <= this.total ? value : this.total)
        )
        this.current = this.go
      }
    },
    getPages() {
      if (this.total <= this.max) {
        let pages = this.setPages(1, this.total)
        this.pages = pages
      }
      const even     = this.max % 2 === 0 ? 1 : 0
      if(this.total < 6) {
        this.prevRange = Math.floor(this.max / (this.max/2))
      } else {
        this.prevRange = Math.floor(this.max / 2)
      }
      this.nextRange = this.total - this.prevRange + 1 + even
      if (this.current >= this.prevRange && this.current <= this.nextRange) {
        const start = this.current - this.prevRange + 2
        const end   = this.current + this.prevRange - 2 - even
        this.pages = [1, '...', ...this.setPages(start, end), '...', this.total]
      } else if (this.total < 6) {
        this.pages = [
          ...this.setPages(1, this.total)
        ]
      } else {
        this.pages = [
          ...this.setPages(1, this.prevRange),
          '...',
          ...this.setPages(this.nextRange, this.total)
        ]
      }
    },
    setPages(start, end) {
      const setPages = []
      for (start > 0 ? start : 1; start <= end; start++) {
        setPages.push(start)
      }
      return setPages
    },
    nextPage() {
      if(this.current < this.total) {
        this.current++
      }
      this.$emit('next')
    },
    prevPage() {
      if(this.current > 1) {
        this.current--
      }
      this.$emit('prev')
    },
  }
}
</script>



<!--

<template>
  <vs-row>
    <vs-col vs-w="4" vs-offset="4">
      <vs-table :hoverFlat="true" class="w-full text-center p-0 pager" :data="[1]" :value="[1]">
        <template slot="thead">
        </template>
        <template slot-scope="{data}">
          <colgroup ref="colgrouptable">
            <col :key="0" :name="`col-0`" width="25%"/>
            <col :key="1" :name="`col-1`" width="50%"/>
            <col :key="2" :name="`col-2`" width="25%"/>
          </colgroup>
          <vs-tr>
              <vs-td class="text-center">
                <vs-button @click="prev($event)" class="inline-block" icon-pack="feather" icon="icon-arrow-left" radius :disabled="v_page == 1"></vs-button>
              </vs-td>

              <vs-td>
                <vs-button class="w-full" type="border" disabled>{{v_page}}</vs-button>
              </vs-td>

              <vs-td class="text-center">
                  <vs-button @click="next($event)" class="inline-block" icon-pack="feather" icon="icon-arrow-right" radius :disabled="!v_hasNext"></vs-button>
              </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-col>
  </vs-row>
</template>

<script>
export default {
  data() {
    return {
      v_page: 1,
      v_hasNext: false,
    }
  },
  props: {
    page: Number,
    hasNext: Boolean
  },
  methods: {
    prev(ev) {
      this.$emit('prev')
      ev.stopPropagation()
    },
    next(ev) {
      this.$emit('next')
      ev.stopPropagation()
    }
  },
  mounted() {
    this.v_page = this.page
    this.v_hasNext = this.hasNext
  },
  watch: {
    page() {
      this.v_page = this.page
    },
    hasNext() {
      this.v_hasNext = this.hasNext
    }
  }
}
</script> -->
